import { createSlice } from "@reduxjs/toolkit";

import { RootState } from "@/redux";

import { ToDoInfo } from "../../pages/ToDo/ToDoList/schema/to-do";
import { toDoApi } from "./to-do.api";

const initialState: ToDoInfo[] = [];

export const toDoSlice = createSlice({
	name: "to-do",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addMatcher(toDoApi.endpoints.getAllToDos.matchFulfilled, (state, { payload }) => {
			return payload ?? [];
		});
		builder.addMatcher(toDoApi.endpoints.createToDo.matchFulfilled, (state, { payload }) => {
			if (payload?.id) {
				return [payload, ...state];
			}
		});
		builder.addMatcher(toDoApi.endpoints.updateToDo.matchFulfilled, (state, { payload }) => {
			if (payload?.id) {
				const index = state.findIndex((todo) => todo.id === payload.id);

				if (index !== -1) {
					state[index] = payload;
				}
			}

			return state;
		});
		builder.addMatcher(toDoApi.endpoints.deleteToDo.matchFulfilled, (state, { payload }) => {
			if (payload?.id) {
				return state?.filter((todo) => todo.id !== payload.id);
			}
		});
	},
});

export const {} = toDoSlice.actions;
export const toDoReducer = toDoSlice.reducer;
export const toDoSelector = (state: RootState) => state[toDoSlice.name];
